import { object, string } from "superstruct";

import Route from "@mpa/toolbox/navigation/Route";

import { loggedInNavigator } from "../../navigation/routes";

export const briefEditorRoute = loggedInNavigator.addRoute(
    new Route().setPath("/brief-editor/:id", object({ id: string() })),
);
